/**
 * @packageDocumentation
 * @module Object
 */
/* eslint-disable max-params */
import { normalisePath } from '../normalisePath';
import { setInBaseFunction } from './setInBaseFunction';
/**
 * Immutably sets a value in an object or array at a given path, denoted by dot notation or an array.
 *
 * If the value is already identical nothing is changed. i.e. values is returned.
 * This function is similar to Lodash 'set', however it also;
 * - will make the path if required
 * - will also merge a given object or array at the path if desired
 *
 * @param {any} values
 * @param {string | string[]} path
 * @param {any} value
 * @param {boolean} mergeAtTarget
 *
 * @return {any}
 */
export var setIn = function (values, path, value, mergeAtTarget) {
    if (mergeAtTarget === void 0) { mergeAtTarget = false; }
    return setInBaseFunction(values, normalisePath(path), value, mergeAtTarget);
};
//# sourceMappingURL=setIn.js.map